<app-uni-dialog
  [parent]="this"
  [contentTemplate]="contentTemplate"
  [footerTemplate]="footerTemplate"
></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-row gap-2 mt-3">
    <uni-field label="Invoice Id">
      <input [ngModel]="invoice.id" pInputText disabled="true" />
    </uni-field>
    <!-- <uni-field label="Status">
      <input [ngModel]="poHeader.poStatus?.name" pInputText disabled="true" />
    </uni-field> -->
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button
      *ngIf="canPreview"
      (click)="showPreview()"
      pButton
      type="button"
      class="p-button-raised"
    >
      Preview
    </button>
    <button
      (click)="printDocument()"
      pButton
      type="button"
      class="p-button-raised"
    >
      Print
    </button>
    <button (click)="close()" pButton type="button" class="p-button-raised">
      Close
    </button>
  </div>
</ng-template>
